import { filter } from 'rxjs/operators';
export const subscribeToEvent = (eventBus, eventType, callback) => eventBus.pipe(filter(event => event.type === eventType)).subscribe(event => callback(event.payload));